<template>
  <div>
    <p class="label">
      <i>
        {{ schoolModel.subTitle.$model }}
      </i>
    </p>

    <w-vue-select
      label-field="name"
      value-field="name"
      :model="schoolModel.selectedSchoolName"
      :values="options"
      :ajax="!isSecretary"
      :taggable="!isSecretary"
      @input="checkIfDeprecated"
      @search="search"
    />

    <template v-if="schoolModel.nodeId.$model">
      <p class="mt-4 mb-0">{{ schoolModel.schoolName.$title }}</p>

      <p>
        <b>{{ schoolModel.schoolName.$model }}</b>

        <br />

        <b>{{ schoolModel.address.prettyAddress.$model }}</b>
      </p>
    </template>
  </div>
</template>

<script>
import components from '@witkac/bootstrap4-components/src/components/formComponents';
import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';
import { schoolPickerChildsOnlyMixin } from '@/mixins/document/schoolPickerChildsOnly';
import { schoolPickerSecretaryMixin } from '@/mixins/schoolPickerSecretary';

// @vuese
// Wybierak szkoły do duplikatów
// @group Forms
export default {
  components,
  mixins: [schoolPickerSecretaryMixin, schoolPickerChildsOnlyMixin],
  computed: mapState({
    mapping: state =>
      JSON.parse(
        (state.setting.settings[PublicSettings.OLD_STRUCTURE_NODE_MAPPING] &&
          state.setting.settings[PublicSettings.OLD_STRUCTURE_NODE_MAPPING].value) ||
          '[]'
      )
        .filter(schoolFromMapping => !schoolFromMapping.hidden)
        .map(schoolFromMapping => {
          schoolFromMapping.loweredName = '' + schoolFromMapping.name.toLowerCase();
          schoolFromMapping.deprecated = true;
          return schoolFromMapping;
        })
  }),
  methods: {
    // @vuese
    // Wyszukuje szkoły
    search(search) {
      this.$store
        .dispatch('structureNode/list', {
          search,
          hasParentOrChildren: true,
          isGuided: true
        })
        .then(result => (this.options = this.processSearchResult(result.list, search)));
    },
    // @vuese
    // Dodaje wyniki z ustawienia mapowania do wyników wyszukiwania
    processSearchResult(list, search) {
      if (!search) {
        return [...list, ...this.mapping];
      }

      const loweredSearch = search.toLowerCase();
      return [...list, ...this.mapping.filter(map => map.loweredName.includes(loweredSearch))];
    },
    // @vuese
    // Sprawdza czy szkoła nie została przekształcona w inną szkołę
    checkIfDeprecated(selectedSchool) {
      this.schoolModel.deprecated.$setData(selectedSchool.deprecated || false);

      if (selectedSchool.deprecated) {
        this.deprecatedSchoolUpdate(selectedSchool.currentNodeId);
      } else {
        this.updateSchoolData(selectedSchool);
      }
    },
    // @vuese
    // Pobranie danych szkoły lub jej węzła nadrzędnego do schemy
    deprecatedSchoolUpdate(nodeId) {
      return this.$store
        .dispatch('structureNode/get', nodeId)
        .then(structureNode =>
          structureNode.parentId
            ? this.deprecatedSchoolUpdate(structureNode.parentId)
            : this.updateSchoolData(structureNode)
        );
    }
  }
};
</script>
